module.exports = __webpack_public_path__ + "static/media/JWB_0557.a2e14c71.jpg";